<template>
  <button @click="toggleAll" v-if="threads.markersVisible">
    Skrýt všechny komentáře
  </button>
  <button @click="toggleAll" v-else>Zobrazit všechny komentáře</button>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  props: {},
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapState(['threads'])
  },
  methods: {
    ...mapActions(['threads/toggleAllGmMarkers']),
    toggleAll() {
      this.$store.dispatch('threads/toggleAllGmMarkers');
    }
  }
};
</script>

<style scoped></style>
